/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Draft_MessagesInputs */



/**
* | output |
* | --- |
* | "Draft emails and messages" |
*
* @param {Onboarding_Usage_Draft_MessagesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_draft_messages = /** @type {((inputs?: Onboarding_Usage_Draft_MessagesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Draft_MessagesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("E-Mails und Nachrichten verfassen")
	return /** @type {LocalizedString} */ ("Draft emails and messages")
});